'use es6';

import { Record } from 'immutable';
export const RequestStatusRecord = Record({
  fetching: false,
  fetched: false,
  syncing: false,
  synced: false,
  fetchFailed: false,
  syncFailed: false,

  fetchedSuccessfully() {
    return !this.fetching && this.fetched && !this.fetchFailed;
  }

});
export const RequestEntryRecord = new Record({
  actionStem: null,
  requestType: null,
  // sync or fetch
  path: null // function (payload) => array of path to setIn

});